import { resolveThresholdTone } from '@/features/projects/components/metricThresholds/utils';
import { isMetricThresholdDisabled } from '@/shared/utils/metricsThresholds';
import type { SemanticColorKey } from '@/theme/semanticTokens';
import type { CoverageMetricThresholdGroup, MetricThreshold } from '@flowqa/shared';

export type CoverageMetricThresholdKey = keyof CoverageMetricThresholdGroup;

const semanticColorByTone: Record<'red' | 'yellow' | 'green', SemanticColorKey> = {
  red: 'error',
  yellow: 'warning',
  green: 'success',
};

export const resolveCoverageMetricThresholdColor = (
  value: number | null | undefined,
  threshold: MetricThreshold,
): SemanticColorKey => {
  if (value === null || value === undefined || isMetricThresholdDisabled(threshold)) {
    return 'textPrimary';
  }

  const tone = resolveThresholdTone(value, {
    warn: threshold.warn,
    target: threshold.target,
    direction: threshold.direction,
  });

  return semanticColorByTone[tone];
};
